import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';

import useSurveySettings from 'src/hooks/useSurveySettings';

import DateFilterControl from './DateFilterControl';

import { styles } from 'src/components/followUp/FilterColumn/index.styles';

const DateFilter: FC<{ comparison?: boolean }> = () => {
  const { t } = useTranslation('myFollowUp');
  const { currentTimePeriodStartDate } = useSurveySettings();

  return (
    <Box sx={styles.filterColumnSection}>
      <Typography variant="body1" sx={{ fontWeight: '600', mb: 2 }}>
        {t('filter.timePeriod')}
      </Typography>
      <DateFilterControl minDate={currentTimePeriodStartDate} />
    </Box>
  );
};

export default DateFilter;
